export default "__VITE_ASSET__BXZ$$cT0__"